import React from "react";

/**
 * Brutalist M C logo  -  inline SVG so it scales perfectly and inherits theme colors.
 * `variant` controls the accent column color ("magenta" default | "cyan" | "mono").
 * `compact` renders a tight square version (just glyphs, no "MALICKE CASE" subline).
 */
export const Logo = ({ className = "", variant = "magenta", compact = false, ariaLabel = "Malicke Case" }) => {
  const accent = variant === "cyan" ? "#4DE1FF" : variant === "mono" ? "#F5F5F7" : "#DC2626";
  const glyphFill = "#F5F5F7";

  if (compact) {
    return (
      <svg
        viewBox="15 10 215 110"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={ariaLabel}
        className={className}
      >
        <rect x="25" y="15" width="8" height="110" fill={accent} />
        <g fill={glyphFill}>
          <path d="M 45,20 H 135 V 85 H 115 V 45 L 95,75 H 85 L 65,45 V 85 H 45 Z" />
          <path d="M 145,20 H 225 V 45 H 175 V 100 H 225 V 125 H 145 Z" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 250 170"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <rect x="25" y="15" width="8" height="140" fill={accent} />
      <g fill={glyphFill}>
        <path d="M 45,20 H 135 V 85 H 115 V 45 L 95,75 H 85 L 65,45 V 85 H 45 Z" />
        <path d="M 145,20 H 225 V 45 H 175 V 100 H 225 V 125 H 145 Z" />
      </g>
      <text x="45" y="150" fontFamily="'JetBrains Mono', monospace" fontSize="10" fontWeight="500" letterSpacing="2.5" fill="#A1A1AA">MALICKE CASE</text>
    </svg>
  );
};
